import UI from "@mile-meeting/mile-ui";
export const TableHeader = () => {
  return (
    <div
      style={{
        display: "flex",
        padding: "12px 24px",
        alignItems: "center",
        backgroundColor: "var(--component-color-fill-alternative)",
        borderRadius: 12,
        gap: 20,
      }}
    >
      <UI.Typography style={{ width: 266, color: "var(--alias-color-label-normal)" }} type="label01">
        회의실
      </UI.Typography>
      <UI.Typography style={{ width: 80, color: "var(--alias-color-label-normal)" }} type="label01">
        요청 상태
      </UI.Typography>
      <UI.Typography style={{ width: 180, color: "var(--alias-color-label-normal)" }} type="label01">
        예약 제한 기간
      </UI.Typography>
      <UI.Typography style={{ flex: 1, color: "var(--alias-color-label-normal)" }} type="label01">
        예약 제한 사유
      </UI.Typography>
      <UI.Typography style={{ width: 74, color: "var(--alias-color-label-normal)" }} type="label01">
        요청 취소
      </UI.Typography>
    </div>
  );
};

export default TableHeader;
